module.exports = __webpack_public_path__ + "img/weatherpedia-pwa1.a02f91e2.jpg";